import axios from "axios";
import { urlCopy } from "../endpoints";

/**
 * Returns the HTML associated with a copy key.
 *
 * @example
 *   const html = await copy('loginMessage');
 *   element.innerHTML = html;
 */
export async function copy(key: string): Promise<string> {
  try {
    const response = await axios.get<string>(
      `${urlCopy}/${encodeURIComponent(key)}`
    );

    if (response.status !== 200) {
      console.error(
        `[copy] ${response.status} ${response.statusText} for key "${key}"`
      );
      return "";
    }
    return response.data;
  } catch {
    return "";
  }
}
